function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { getProductTypeById, getProductPath } from '@finect/front-resources/Products';
import { Link } from 'react-router-dom';
import { dataLayer } from '@finect/front-gtm';
import { Tag } from '../../Tags';
import { getProductName } from '../utils';
import { reviewsFeaturesCatalog, featuresToShow } from './utils';
import { ProductOrganizations } from './ProductOrganizations';
import { LikeAction } from './LikeAction';
import { Ratings } from './Ratings';
import { BuyButton } from './BuyButton';
import { SocialStats } from './SocialStats';
import { Header, ProductName, Divider, FeatureSetBlock, OrganizationsBlock, Inner } from './partials';
export var MediumProductCard = function (_React$Component) {
  _inherits(MediumProductCard, _React$Component);
  var _super = _createSuper(MediumProductCard);
  function MediumProductCard() {
    var _this;
    _classCallCheck(this, MediumProductCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleTransactionClick", function () {
      var _this$props = _this.props,
        onAction = _this$props.onAction,
        product = _this$props.product;
      typeof onAction !== 'undefined' && onAction(product);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMoreInfo", function (evt) {
      var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var withSPA = _this.props.withSPA;
      !withSPA && evt.preventDefault();
      var path = getProductPath(_this.props.product, _this.props.context || []);
      var layer = {
        id: 'ProductCard',
        type: 'productClick',
        params: {
          product: _this.props.product,
          position: null,
          element: element
        },
        callback: withSPA ? undefined : function () {
          window.location = "".concat(path);
        }
      };
      dataLayer(layer);
    });
    return _this;
  }
  _createClass(MediumProductCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$product = this.props.product,
        entity = _this$props$product.entity,
        subtype = _this$props$product.subtype;
      var features = entity.features;
      var _this$props2 = this.props,
        following = _this$props2.following,
        onFollow = _this$props2.onFollow,
        product = _this$props2.product,
        onAction = _this$props2.onAction,
        withProductType = _this$props2.withProductType,
        withSPA = _this$props2.withSPA,
        context = _this$props2.context,
        _this$props2$distribu = _this$props2.distributorsWhiteList,
        distributorsWhiteList = _this$props2$distribu === void 0 ? [] : _this$props2$distribu;
      var productType = getProductTypeById(subtype);
      var path = getProductPath(product, context);
      var featuring = false;
      var nameLinkProps = withSPA ? {
        as: Link,
        to: path
      } : {
        as: 'a',
        href: path,
        target: '_top'
      };
      return React.createElement(Inner, {
        featuring: featuring
      }, React.createElement(Header, {
        first: true
      }, onFollow ? React.createElement(LikeAction, {
        onClick: function onClick() {
          return onFollow(entity.id, !following, entity);
        },
        active: following
      }) : null, withProductType ? React.createElement(Tag, {
        small: true
      }, productType.shortSingular) : null, React.createElement("div", null, React.createElement(ProductName, _extends({
        onClick: function onClick(event) {
          _this2.handleMoreInfo(event, 'title');
        }
      }, nameLinkProps, {
        verticalAlign: 'start'
      }), React.createElement("span", null, getProductName(productType, entity))))), React.createElement(SocialStats, {
        product: product,
        context: context,
        display: "block",
        showEmpty: true,
        showNewBadge: true
      }), React.createElement(OrganizationsBlock, {
        bottom: true
      }, React.createElement(ProductOrganizations, {
        product: product,
        whiteList: distributorsWhiteList
      })), React.createElement(Divider, null), React.createElement(FeatureSetBlock, {
        topMargin: true
      }, React.createElement(Ratings, {
        score: entity.score,
        catalog: reviewsFeaturesCatalog,
        features: features,
        show: featuresToShow.cards.large,
        withFeatures: true
      })), onAction ? React.createElement(BuyButton, {
        product: product,
        onAction: this.handleTransactionClick
      }) : null);
    }
  }]);
  return MediumProductCard;
}(React.Component);
_defineProperty(MediumProductCard, "defaultProps", {
  withProductType: true,
  withSPA: false
});